import { browser } from '@atlaskit/editor-common/browser';
import { NodeSelection, TextSelection } from '@atlaskit/editor-prosemirror/state';
import { akEditorDefaultLayoutWidth, akEditorFullWidthLayoutWidth } from '@atlaskit/editor-shared-styles';
import { setBreakoutWidth } from '../editor-commands/set-breakout-width';
var KEYBOARD_RESIZE_STEP = 10;
var getAncestorResizableNode = function getAncestorResizableNode(view, breakoutResizableNodes) {
  var selection = view.state.selection;
  if (selection instanceof NodeSelection) {
    var selectedNode = selection.node;
    if (breakoutResizableNodes.has(selectedNode.type)) {
      return {
        node: selectedNode,
        pos: selection.$from.pos
      };
    }
  } else if (selection instanceof TextSelection) {
    var node = null;
    var nodePos = null;

    // only top level nodes are resizable
    var resolvedPos = view.state.doc.resolve(selection.$from.pos);
    var currentNode = resolvedPos.node(1);
    if (breakoutResizableNodes.has(currentNode.type)) {
      node = currentNode;
      nodePos = resolvedPos.before(1);
      return {
        node: node,
        pos: nodePos
      };
    }
  }
  return null;
};
export var handleKeyDown = function handleKeyDown(api) {
  return function (view, event) {
    var metaKey = browser.mac ? event.metaKey : event.ctrlKey;
    var isBracketKey = event.code === 'BracketRight' || event.code === 'BracketLeft';
    if (metaKey && event.altKey && isBracketKey) {
      var _view$state$schema$no = view.state.schema.nodes,
        expand = _view$state$schema$no.expand,
        codeBlock = _view$state$schema$no.codeBlock,
        layoutSection = _view$state$schema$no.layoutSection;
      var breakoutResizableNodes = new Set([expand, codeBlock, layoutSection]);
      var result = getAncestorResizableNode(view, breakoutResizableNodes);
      if (result) {
        var node = result.node,
          pos = result.pos;
        var breakoutMark = node === null || node === void 0 ? void 0 : node.marks.find(function (mark) {
          return mark.type.name === 'breakout';
        });
        if (breakoutMark) {
          var step = event.code === 'BracketRight' ? KEYBOARD_RESIZE_STEP : -KEYBOARD_RESIZE_STEP;
          var newWidth = breakoutMark.attrs.width + step;
          if (newWidth < akEditorFullWidthLayoutWidth && newWidth > akEditorDefaultLayoutWidth) {
            var _api$editorViewMode;
            var isEditMode = (api === null || api === void 0 || (_api$editorViewMode = api.editorViewMode) === null || _api$editorViewMode === void 0 || (_api$editorViewMode = _api$editorViewMode.sharedState.currentState()) === null || _api$editorViewMode === void 0 ? void 0 : _api$editorViewMode.mode) === 'edit';
            setBreakoutWidth(breakoutMark.attrs.width + step, breakoutMark.attrs.mode, pos, isEditMode)(view.state, view.dispatch);
            view.focus();
          }
          return true;
        }
      }
    }
    return false;
  };
};